// extracted by mini-css-extract-plugin
export var baseButton = "_we-0";
export var controlsArrowKeys = "_we-1";
export var controlsResetButton = "_we-2";
export var lightGameButton = "_we-4 _we-0";
export var playAgainButton = "_we-5 _we-0";
export var startGameButton = "_we-3 _we-0";